//homepage skin science slider starts
// function loader_hit(){
//     $(".loaderChekout").show();
//     $(".loaderChekout-overlay").show();    
//   }
// sid code 5/6/2023
if($(window).width() < 768){
  $('.cstm__reviews_products').html('');
}
// sid code end 5/6/2023
$( document ).ready(function() {
     function cartPopup(){
              setTimeout(function(){
                 var header__cart__status = parseInt(document.querySelector('.header__cart__status').innerText);
                 var cart__total__money = cart.cartTotal.textContent;
                 console.log(cart__total__money,'header__cart__status',header__cart__status);
                 if(header__cart__status != 0){
                   document.querySelector('.add_to_cart_container').classList.add("block");
                   document.querySelector('.quntity_add').innerText = header__cart__status + ' Item | ' + cart__total__money;
                   setTimeout(function(){
                      document.querySelector('.add_to_cart_container').classList.remove("block");
                  },5000);
                }
               },2500);
           }

  
window.onscroll = function() {myFunction()};
var header = document.getElementById("my_sticky_header");
var sticky = header.offsetTop;
var headerheight = $(header).height() + 20;
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}
  // 23-3-23 remove multilocation code as benglore and kolkatta invetory
  // var ExistPincode = localStorage.getItem('ExistPincode');
  // if(!ExistPincode && !$('body').hasClass('template-page')){
  //     setTimeout(function(){
  //     $("#myPopup").show();
  //     },2000);
  // }
   localStorage.setItem('out_of_stock','0');
   $("#checkout").click(function(e){
      e.preventDefault();
     // e.stopPropogation();
    $(".Main_container").css("display","block");
     window.location.href="/checkout??step=contact_information";
   });
  var template = $('body').hasClass('hasvariants');
     if(template)  
    {
      $('.blog-list').slick({  
      speed: 900,
    	arrows: true,
   		slidesToScroll: 1,
  		slidesToShow: 5,
     	infinite: true,
   		 prevArrow:'<button type="button" class="slick-prev hhhh"><svg class="Icon Icon--select-arrow-left" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></button>',
         nextArrow:'<button type="button" class="slick-next"><svg class="Icon Icon--select-arrow-right" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></button>',
    	responsive: [
         {
      	   breakpoint: 750,
      	   settings: {
           slidesToShow: 1,
           slidesToScroll: 1,
           centerMode: true,
     	   centerPadding: '210px',        
      	   }
    	 },
         {
      	   breakpoint: 650,
      	   settings: {
           slidesToShow: 1,
           slidesToScroll: 1,
           centerMode: true,
     	   centerPadding: '170px',        
      	   }
    	 },
         {
      	   breakpoint: 550,
      	   settings: {
           slidesToShow: 1,
           slidesToScroll: 1,
           centerMode: true,
     	   centerPadding: '40px',      //sid  
      	   }
    	 },
         {
      	   breakpoint: 430,
      	   settings: {
           slidesToShow: 1,
           slidesToScroll: 1,
           centerMode: true,
     	   centerPadding: '110px',        
      	   }
    	 }
        ]
	  });
    }    
//homepage skin science slider ends
    
/****************** for more article- skin science page************/
    else {
// 	  if(($(window).width() > 1008)){
   		$('.blog-list ').slick({  
    	speed: 900,
    	arrows: true,
   		slidesToScroll: 1,
  		slidesToShow: 5,
     	infinite: true,
   		 prevArrow:'<button type="button" class="slick-prev"><svg class="Icon Icon--select-arrow-left" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></button>',
         nextArrow:'<button type="button" class="slick-next"><svg class="Icon Icon--select-arrow-right" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></button>',
        responsive: [
         {
      	   breakpoint: 1008,
      	   settings: {
           slidesToScroll: 1,
  		   slidesToShow: 3,       
      	   }
    	 }
        ]
		});
    }
   if($('body').hasClass('template-product')){
  $(".cstm_atc_after_load").show();
   $(".cstm_atc_before_load").hide();  
   }
  });
// hide menu on scroll
$(window).scroll(function(){
      if ($(window).scrollTop()) {
//        $('#shopify-section-header').css('height','20')
        $("#header-desktop").addClass('menu-change');
//         $("#header-height").addClass('.header-cstm');
        $("#header-height").removeClass('header-cstm');
         $("#header-height").addClass('.header-cstmadd').css('height','auto');;
      }
  else{
     $("#header-desktop").removeClass('menu-change');
    $("#header-height").removeClass('.header-cstmadd').css('height','auto');
    $("#header-height").addClass('header-cstm');
  	}
         
    });
$(document).ready(function(){
//   getCity(pincode_1);
    var ExistPincode = localStorage.getItem('ExistPincode');
  if(ExistPincode !== null){
   getCity(ExistPincode);
  }
  function getCity(pincode_1){
//   $.get("https://maps.googleapis.com/maps/api/geocode/json?address="+pincode_1+"&sensor=true&key=AIzaSyDRpoMybEkazzpTHqRL0Yc9P9kqlbltkcs", function(data, status){
//     var data_pincodes = data.results[0].formatted_address;
//     //var data_pincodes_length = data_pincodes.length;
//      var city_new = data_pincodes.split(',')[0];
//     var pin_val = $('.pincode-1').val();
// //     var city_new = data_pincodes[data_pincodes_length - 3].long_name;
//     $('.deleverypin').text("Deliver to: " +city_new+" "+"("+pin_val+")");
//     $('.changepin').text("Change");
//    $('.pincode_cstm').css('display','none');
//      localStorage.setItem('PincodeCity', city_new);
//   });
       $.getJSON(`https://api.postalpincode.in/pincode/${pincode_1}`, function(data) {
        var data_pincodes = data[0].PostOffice[0].Pincode;
        var data_pincodes_length = data_pincodes.length;
        if(data[0].PostOffice[0].Block == 'NA'){var city_new = data[0].PostOffice[0].District;}
                                          else{var city_new = data[0].PostOffice[0].Block;}
        
        var state_new = data[0].PostOffice[0].State;
        var country_new = data[0].PostOffice[0].Country;
        var pin_val = $('.pincode-1').val();
        $('.deleverypin').text("Deliver to: " +city_new+" "+"("+pin_val+")");
    $('.changepin').text("Change");
    $('.pincode_cstm').css('display','none');
     localStorage.setItem('PincodeCity', city_new);
      });
  }
  
// Add custom code below this line
//  _________________________ PINCODE VALIDATION ________________________________________ 
  
  if(window.theme.pincodeValidatorEnable){
 // 23-3-23 remove multilocation code as benglore and kolkatta invetory 
 //   var array_location = window.theme.list_of_locations;
 //   var location_1 = '';
 //   
 //  var closePopup = localStorage.getItem("closePop");
 // var ExistPincode = localStorage.getItem('ExistPincode');
 // var PinMsg = localStorage.getItem('PinMsg');
 // if(ExistPincode !=''){
 //   $('.pincode-1').val(ExistPincode);
 //   $('.pin-validate-btn span').text("Submit");
 //   $('.change_pincode').show();
 //   $('.pin_msg').text(PinMsg).css('color','#000');
 //  
 // }else{
 //   $('.pincode-validation.product-pin').show();
 // }
 // const pin_list_1 = window.theme.pincodeList_1;
 // const pin_list_2 = window.theme.pincodeList_2; 
 // const pin_list_3 = window.theme.pincodeList_3;
 // const pin_list_4 = window.theme.pincodeList_4;  
 // $('.pin-validate-btn').click(function(i){
 //    $('.dis_error-msg').hide();
 //   var popup_open = $('.popup-pincode').css('display');
 //   if (popup_open == "block"){
 //     var pin_1 = $('.popup-pincode-inner .pincode-1');
 //     var pincode_1 =  pin_1.val();
 //     if(!pincode_1){
 //     localStorage.setItem('ExistPincode', '');
 //     localStorage.setItem('PincodeCity', '');  
 //       $('.pincode_cstm').css('display','contents'); 
 //      $('.deleverypin').text(""); 
 //       $('.changepin').text("");
 //       
 //     }
 //   }else{
 //     var pin_1 = $(this).parent('.pincode-validator').find('input.pincode-1');
 //     var pincode_1 = pin_1.val();
 //   } 
 //   if (/^(\d{6})$/.test(pincode_1)) {
 //     if ( $.inArray(pincode_1, pin_list_1) > -1) {
 //      localStorage.setItem('ExistPincode', pincode_1);
 //       localStorage.setItem('storepincode', pincode_1);
 //       $('.pincode-1').attr('placeholder', 'Enter PIN').css('color','#000');
 //       if (popup_open == "block"){
 //       setTimeout(function(){$('.popup-pincode').hide();},500);
 //       }
 //       $('.pincode-1').val(pincode_1);
 //       $('.pin-validate-btn span').text("Submit");
 //       $('.pincode-validation.product-pin').hide();
 //       $('.change_pincode').show();
 //       location_1 = array_location[0];
 //       localStorage.setItem('currentLocationId', location_1);
 //       console.log(location_1);
 //       inventory_sync(location_1);
 //       //location.reload();
 //       
 //     }else if ($.inArray(pincode_1, pin_list_2) > -1){
 //       localStorage.setItem('ExistPincode', pincode_1);
 //       localStorage.setItem('storepincode', pincode_1);
 //       $('.pincode-1').attr('placeholder', 'Enter PIN').css('color','#000');
 //       if (popup_open == "block"){
 //       setTimeout(function(){$('.popup-pincode').hide();},500);
 //       }
 //       $('.pincode-1').val(pincode_1);
 //       $('.pin-validate-btn span').text("Submit");
 //       $('.pincode-validation.product-pin').hide();
 //       $('.change_pincode').show();
 //       location_1 =  array_location[1];    
 //       localStorage.setItem('currentLocationId', location_1);
 //       console.log(location_1);
 //       inventory_sync(location_1);
 //       //location.reload();
 //     }else if ($.inArray(pincode_1, pin_list_3) > -1){
 //       localStorage.setItem('ExistPincode', pincode_1);
 //       localStorage.setItem('storepincode', pincode_1);
 //       $('.pincode-1').attr('placeholder', 'Enter PIN').css('color','#000');
 //       if (popup_open == "block"){
 //       setTimeout(function(){$('.popup-pincode').hide();},500);
 //       }
 //       $('.pincode-1').val(pincode_1);
 //       $('.pin-validate-btn span').text("Submit");
 //       $('.pincode-validation.product-pin').hide();
 //       $('.change_pincode').show();
 //       location_1 =  array_location[2];    
 //       localStorage.setItem('currentLocationId', location_1);
 //       console.log(location_1);
 //       inventory_sync(location_1);
 //       //location.reload();
 //     }else if ($.inArray(pincode_1, pin_list_4) > -1){
 //       localStorage.setItem('ExistPincode', pincode_1);
 //       localStorage.setItem('storepincode', pincode_1);
 //       $('.pincode-1').attr('placeholder', 'Enter PIN').css('color','#000');
 //       if (popup_open == "block"){
 //       setTimeout(function(){$('.popup-pincode').hide();},500);
 //       }
 //       $('.pincode-1').val(pincode_1);
 //       $('.pin-validate-btn span').text("Submit");
 //       $('.pincode-validation.product-pin').hide();
 //       $('.change_pincode').show();
 //       location_1 =  array_location[3];    
 //       localStorage.setItem('currentLocationId', location_1);
 //       console.log(location_1);
 //       inventory_sync(location_1);
 //       //location.reload();
 //        
 //     }else{
 //       pin_1.focus().attr('placeholder', 'Delivery not available..').css('color','red');
 //       //$('.pincode-1').val('');
 //       $('.pin_msg').text("Apologies, we do not currently service your location. We will be there soon!").css('color','red');
 //       $('.pin-validate-btn span').text("Submit");
 //       localStorage.setItem('ExistPincode', '');
 //       localStorage.setItem('storepincode', '');
 //       localStorage.setItem('PinMsg', '');
 //       $('.change_pincode').hide();
 //     	$('.pincode-validation.product-pin').show();
 //       $('.shopify-payment-button__button').attr("disabled","disabled");
 //     }
 //   } else {
 //      pin_1.focus().attr('placeholder', 'Invalid PIN').css('color','red'); $('.pincode-1').val('');
 //     	localStorage.setItem('PinMsg', '');
 //    	$('.pin_msg').text('');
 //     	$('.change_pincode').hide();
 //     	$('.pincode-validation.product-pin').show();
 //       $('.pin-validate-btn span').text("Submit");
 //       localStorage.setItem('ExistPincode', '');
 //      localStorage.setItem('storepincode', '');
 //      $('.shopify-payment-button__button').attr("disabled","disabled");
 //     	
 //     return false;
 //   }
 // }); 
 
// 23-3-23 remove multilocation code as benglore and kolkatta invetory
//  const atc_btn = $('[data-quick-add-label],[data-button-quick-add-mobile]').click(function(evt){
//    
//    var ExistPincode = localStorage.getItem('ExistPincode');
//    var currentLocationId =  localStorage.getItem('currentLocationId');
//    if(currentLocationId == null){
//      evt.preventDefault();
//      evt.stopPropagation();
//      $('.popup-pincode').show();
//      
//    }
//    if(!(ExistPincode)){
//      evt.preventDefault();
//      evt.stopPropagation();
//      $('.popup-pincode').show();
//    }else{
//      setTimeout(function(){
//      var ExistLocation_form = localStorage.getItem('currentLocationId');
//      //$(".form-quick-add .span_quick_class").hide();
//        $(".form-quick-add .span_quick_class input").prop("disabled", true);
//    var array_all_search = localStorage.getItem("array_all");
//    var array_all_search_list = JSON.parse(array_all_search);
//   
//    var inventory_location_avaiable = array_all_search_list[ExistLocation_form];
//    
//    for (const [key, value] of Object.entries(inventory_location_avaiable)) {
//      //console.log(key, value);
//      if(value > 0){
////         if(window.theme.template_name.match("product") != null){
////          // no action on product page
////         }else{
////           ////$(".variantId_"+key).show();
////           ////console.log(key);
////           ////console.log($(".form-quick-add .span_"+key ));
////           //$(".form-quick-add .span_"+key ).show();
////           $(".form-quick-add .span_"+key+" input" ).prop("disabled", false);
////         }
////         // common this code for collection home and product page you may like section
//         $(".form-quick-add .span_"+key+" input" ).prop("disabled", false);
//      }
//    }
//    },1000);    
//    }
//  });
// 23-3-23 remove multilocation code as benglore and kolkatta invetory
//  $('.hdrpin').click(function(evt){
//    var autofillinputPincode = localStorage.getItem('autofillpincode');
//    $('.autofill-popup input').removeAttr('checked');
//    if(autofillinputPincode=='autofill'){
//    $('.autofill__pincode').attr('checked','checked');
//    $('input.popup-validator.pin.pincode.pincode-1').attr('disabled','disabled');  
//    }
//    else{
//    $('.manual__pincode').attr('checked','checked');
//     $('input.popup-validator.pin.pincode.pincode-1').removeAttr('disabled');  
//    }
//    $('.popup-pincode').show();
//  });
//    $('.popup-pincode-inner .close').on('click', function(){
//     var closePopup = localStorage.setItem("closePop",'true');
//     $('.popup-pincode').hide();
//     var pop_val= $('.popup-validator').val();
//      if(!pop_val){
////         alert(pop_val);
//      localStorage.setItem('ExistPincode', '');
//      var ExistPincode = localStorage.getItem('ExistPincode');
////         alert(ExistPincode);
//      }
//        
//      
//  });
//     const atc_btn1 = $('.atc-btn').click(function(evt){
//    var ExistPincode = localStorage.getItem('ExistPincode');
//    if(!(ExistPincode)){
//      evt.preventDefault();
//      evt.stopPropagation();
//      $('.popup-pincode').show();
//    }
//  });
     
  $(window).on("load",function(){
	$('.shopify-payment-button__button').attr("disabled","disabled");
  		 var ExistPincode_load = localStorage.getItem('ExistPincode');
     if((ExistPincode_load)){
     	$('.shopify-payment-button__button').removeAttr("disabled");
     }
  //setTimeout(()=>{$('.login-pop-up').show()},3000)
});
//  if((closePopup == "true") || (ExistPincode)){
//     $('.popup-pincode').hide();
//   }else if(ExistPincode != "true"){
//     $('.popup-pincode').show();
//   }   
}
//    const plus_icon = $('.cart__quantity-plus').click(function(evt){
//     var ExistPincode = localStorage.getItem('ExistPincode');
//     if((ExistPincode !='')){
//       evt.preventDefault();
//       evt.stopPropagation();
//       $('.popup-pincode').show();
//     }
//   });

  /**************footer accordion***********/
  if($(window).width()<= 749){
    $('.footer-acc-heading').click(function(e) {
  	e.preventDefault();
    let $this = $(this);
    if ($this.hasClass('show-acc')) {
        $this.removeClass('show-acc');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('.footer-acc-heading').removeClass('show-acc');
        $this.parent().parent().find('.footer-acc-content').slideUp(350);
        $this.toggleClass('show-acc');
        $this.next().slideToggle(350);
    }
});
  }
    /**************End footer accordion***********/
 
  //______________________________autofill popup on load_____________________________// 

  
// 23-3-23 remove multilocation code as benglore and kolkatta invetory
//  //  var ExistPincode = localStorage.getItem('ExistPincode');
//  // if(!ExistPincode){
//  //   getLocation();
//  // }
//    function getLocation() {
//      if (navigator.geolocation) {
//        navigator.geolocation.getCurrentPosition(showPosition);
//      } else {
//        alert("Geolocation is not supported by this browser.");
//      }
//    }
//
//  function showPosition(position) {
//    var lat=position.coords.latitude;
//    var lng=position.coords.longitude;
//    var latlng = new google.maps.LatLng(lat, lng);
//    var geocoder = new google.maps.Geocoder();
//    geocoder.geocode({ 'latLng': latlng },  (results, status) =>{
//      if (status !== google.maps.GeocoderStatus.OK) {
//        alert(status);
//      }
//      if (status == google.maps.GeocoderStatus.OK) {
////         console.log(results[0].address_components[8].long_name);
////         console.log(results[0]);
//        var postalpin ='';
//        for(var i=0;i<results.length;++i){
////           console.log(results[i].types[0]);
//            var postal=results[i].types[0].trim();
//                 if(postal == "postal_code"){
//                    postalpin = results[i].address_components[0].long_name;
////                   console.log(results[i].address_components[0].long_name); 
//                 }
//                }
////         if (!postalpin) {
////         console.log('not found');
////         }else
////         {
////            console.log(postalpin);
////         }
////         var pincode_auto =results[0].address_components[8].long_name;
//        var pincode_auto=postalpin;
//         $('.autofill_picode').text('('+pincode_auto+')');
//        var ExistPincode = localStorage.getItem('ExistPincode');
//        var autofillinputPincode = localStorage.getItem('autofillpincode');
////         alert(ExistPincode);
//        if(ExistPincode =='' || ExistPincode === null ||autofillinputPincode=='autofill' && pincode_auto){
//         localStorage.setItem('autofillpincode', 'autofill');  
//        localStorage.setItem('ExistPincode', pincode_auto);
//        localStorage.setItem('storepincode', pincode_auto);
//        var ExistPincode = localStorage.getItem('ExistPincode');
//        var PinMsg = localStorage.getItem('PinMsg');
//        if(ExistPincode !=''){
//          $('.pincode-1').val(ExistPincode);
//          $('.pin-validate-btn span').text("Submit");
//          $('.change_pincode').show();
//          $('.pin_msg').text(PinMsg).css('color','#000');
//          getCity(ExistPincode);
//        }
//  } 
//      }
//    });
//  }
  /*________________________pop check  autofill and manual_______________________*/ 
 
  // $('.autofill-popup input').change(function(){
  //   var input_val = $(this).val();
  //   if(input_val=='autofill'){
  //     getLocation();
  //     function getLocation() {
  //       if (navigator.geolocation) {
  //         navigator.geolocation.getCurrentPosition(showPosition);
  //       } else {
  //         alert("Geolocation is not supported by this browser.");
  //       }
  //     }
  //      $('input.popup-validator.pin.pincode.pincode-1').attr('disabled','disabled');
  //     localStorage.setItem('autofillpincode', 'autofill');
  //   }
  //   else{
  //    $('input.popup-validator.pin.pincode.pincode-1').removeAttr('disabled');  
  //   localStorage.setItem('autofillpincode', 'manual');
  //   }
  // });

  /*________________________Endpop check  autofill and manual_______________________*/ 

//______________________________End autofill popup on load_____________________________// 

  
});


// $(document).ready(function(){
//   if ($(window).width() > 768 )  {
//    $('.thumbs-holder').slick({
//    slidesToShow: 6,
//    slidesToScroll: 1,
//    arrows: true,
// //     dots:false,
//      infinite: false,
//    prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
//    nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>',  
//   });
//   }
//  });

// Announce Bar here
if($('#shopify-section-announcement').length) {
  $('.close_announce_bar').click(function() {
 $('#shopify-section-announcement').hide();
  localStorage.setItem('barDismissed', true);  
  });
  
   if (localStorage.getItem('barDismissed')) {
     $('#shopify-section-announcement').hide();
   }
}
// sticky Add to cart
  if ($(window).width() < 768 )  {
  $(window).scroll(function(){
        if ($(window).scrollTop() > 850 ) {
          $(".custm-sticky-btn").show();
        }
        else{
          $(".custm-sticky-btn").hide();
        }    
      });
      $('.sticky_btn').click(function(){
        $(this).parents('[data-product-form]').find('button[name="add"]').trigger('click');
      });
  }

  if ($(window).width() > 768 )  {
  $(window).scroll(function(){
        if ($(window).scrollTop() > 540 ) {
          $(".desktop-sticky-container-parent").show();
        }
        else{
          $(".desktop-sticky-container-parent").hide();
        }    
      });
      // $('.sticky_btn_desktop').click(function(){
      //   $('body').find('[data-product-form] button[name="add"]').trigger('click');
      // });
  }
  
// According for collection
// $(document).on('load', function(){
//  ('.help-acc-content').slideUp();
// }
 $('.help-acc-heading').click(function(e) {
  	e.preventDefault();
    let $this = $(this);
    if ($this.hasClass('show-acc')) {
        $this.removeClass('show-acc');
        $this.next().slideUp(350);
    } else {
        $this.parent().parent().find('.help-acc-heading').removeClass('show-acc');
        $this.parent().parent().find('.help-acc-content').slideUp(350);
        $this.toggleClass('show-acc');
        $this.next().slideToggle(350);
    }
});

// review scroll top to bottom
$(".cstm-review").click(function() {
    $('html,body').animate({
        scrollTop: $("#shopify-product-reviews").offset().top-100},
        'slow');
});



//  For variant thmubnail images

setTimeout(function(){
 if(($(window).width() > 1008)){
    //       alert();
    $('.Product__SlideshowNavImage_no_variant .thumbs-holder').slick({
      infinite: false,
      autoplay: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>'
    });
  } else{
    $('.Product__SlideshowNavImage_no_variant .thumbs-holder').slick({
      infinite: false,
      autoplay: false,
      slidesToShow:4,
      slidesToScroll: 1, 
      arrows: true,
      dots: false,
      prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>'
    });
  }
},1000);

if(window.theme.routes.pageType == 'product'){ 
 $('body').on('click','.product__selectors input',function(){
    setTimeout(function(){
     // let SalePrice = $('.form__inner__wrapper').find('.product__price__wrap .p-sale-price').attr('data-product-price');
        let SalePrice = $('.form__inner__wrapper').find('.product__price__wrap .p-sale-price').text().replace('₹','');
        console.log('SalePrice',SalePrice);
       $('.cstm_add_to_cart_quantity').find('.atc-btn').attr('product-price',SalePrice);
     },300);
   
    var swatchAlt= $(this).val().toLowerCase().replace(/ /g, '');
   // alert(swatchAlt);
    $('.thumb_main').slick('unslick');
    thumbImages(swatchAlt);
  });
  
  if($('body').hasClass('hasvariants')){

var swatchAlt= $('.product__selectors input:checked').val().toLowerCase().replace(/ /g, '');
// var swatchAlt = undefined; 
// alert(swatchAlt);
  if(swatchAlt!=undefined){
    setTimeout(function(){
    thumbImages(swatchAlt);
      },1000);
  } 
  }
}

function thumbImages(swatchAlt){
//       alert(swatchAlt);
    $('.single-image-selected').unwrap();
    $('.main-image-selected').unwrap();
    $('.thumbs-holder .thumb ').each(function(){
      var media_alt =$(this).attr('media-alt').toLowerCase().replace(/ /g, '');
      var media_alt_split = media_alt.split('|')[1];
      if(media_alt_split==swatchAlt){
         $(this).show();
        $(this).addClass('single-image-selected');
      } 
//       alert(media_alt+'=='+swatchAlt);
     else if(media_alt==swatchAlt){
        $(this).show();
        $(this).addClass('single-image-selected');
      }
      else{
        $(this).hide();
        $(this).removeClass('single-image-selected');
      }
    });
    $('.single-image-selected').wrapAll('<div class="thumb_main"></div>');
    mainthumbslider();
  }
 function mainthumbslider(){
    //   alert('kk');
    if(($(window).width() > 1008)){
            
      $('.thumb_main').slick({
        infinite: false,
        autoplay: false,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>'
      });
    } else{
      $('.thumb_main').slick({
        infinite: false,
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 1, 
        arrows: true,
        dots: false,
        prevArrow: '<button class="slick-prev"><i class="fa fa-angle-left"></i></button>',
      nextArrow: '<button class="slick-next"><i class="fa fa-angle-right"></i></button>'
      });
    }

  }
// 23-3-23 remove multilocation code as benglore and kolkatta invetory
function cartUpdateWhilePincodeUpdate(ExistLocation_form,redirect){
  $.getJSON('/cart.json', function(cart, index){
    var updateData = {}; 
     cart.items.forEach(function(item){
       var item_id = item.id;
       var array_all_search = localStorage.getItem("array_all");
     
  	   var array_all_search_list = JSON.parse(array_all_search);
       var availabe_sku = array_all_search_list[ExistLocation_form][item_id];
       if(availabe_sku <= 0){
         //remove_to_free_item(item_id);
         updateData[item_id] = 0;
       }
     });
    
      //console.log("updateData length");
      //console.log(updateData.length);
      //console.log(Object.keys(updateData).length);
      if(Object.keys(updateData).length > 0){
        //console.log("updateData");
        //console.log(updateData);
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: updateData
          },
          dataType: 'json',
          success: function(cart){
            $(".PageOverlay").addClass("is-visible");
            $("#atc-message").html("Cart has been updated Successfully.");
            $("#atc-notification , .atc-shipping").show();
            $("#atc-notification-removed").hide();
            
            
            //window.location.href = "";
             if(redirect == true){
            	window.location.href = "";
            }
          },
          error: function(err){
            console.error('Booo!', err)
          }
        });

      }else{
         if(redirect == true){
            	window.location.href = "";
         }
        //window.location.href = ""
      }
  });
  
}

function inventory_sync(ExistLocation_form){
   var array_all = [];
   if(ExistLocation_form != null){
     var url = window.theme.heroku_link+"location/invlocation.php?lid="+ExistLocation_form;
        axios({
          //url: "https://ushoplocation.herokuapp.com/index.php?lid="+ExistLocation_form,
          //url: "https://www.ens.enterprises/multibrand/location/invlocation.php?lid="+ExistLocation_form,
          url: url ,
          method: "GET",
        }).then((result) => {
          //console.log("********************result************************************");
          //console.log(result)
          if(result.data.length !=0 ){
            //console.log(result.data); 
            //console.log("***********cccc")          
            var object_1_length = [];        
            if(result.data[ExistLocation_form] != undefined){
            		var object_1_length =  Object.keys(result.data[ExistLocation_form]).length;
            }          
            //console.log("***** object is not zero*****");
            if(object_1_length > 1){
              //console.log("***** Key is not zero*****");
              //console.log("****enter result*****");
              array_all = result.data;                
              localStorage.setItem("array_all", JSON.stringify(array_all));            
              //window.location.href = "";
              cartUpdateWhilePincodeUpdate(ExistLocation_form,true);
            }
          }else{
            //console.log("******result_0********");
          }
          
        }).catch(err => {
          //console.log(err)
        });
      }
}

// small cart popup by ritu

$('body').on('click','.navlink--cart' ,function(e){
let tgt_cart =  document.getElementById("cart-dropdown");
let newclass = "overlay_class";
var root = document.getElementsByTagName( 'body' )[0];
root.classList.add(newclass);
if( !tgt_cart.classList.contains("cart_is_open")){
tgt_cart.classList.add("cart_is_open");
}
tgt_cart.classList.add("is_open");
root.style.overflow = "hidden";
const myDiv = document.getElementById('cart-dropdown');
if (document.body.classList.contains("overlay_class")) { 
document.querySelector(".overlay_background").addEventListener('click', function(event) {
if (!event.target.closest('#cart-dropdown')) {
const myDiv = document.getElementById('cart-dropdown');
myDiv.classList.remove('cart_is_open');
document.body.classList.remove("overlay_class");
var root = document.getElementsByTagName( 'body' )[0];
root.style.overflow = "visible";
}
});
}
const element1 = document.querySelector('[data-scroll-locked]');
if (element1 && element1.hasAttribute('data-scroll-locked')) {
  const myDiv1 = document.querySelector('.header__mobile__hamburger');
   myDiv1.click();
   document.body.classList.remove("menu_overlay")                      
}
});
document.querySelector('#view_cart_page_id').addEventListener('click', function(e) {
  $('.navlink--cart').trigger('click');
});
document.querySelector('.cart-dropdown__close').addEventListener('click', function(e) {
  let tgt_cart =  document.getElementById("cart-dropdown");  
  tgt_cart.classList.remove("cart_is_open");
  let newclass = "overlay_class";
  var root = document.getElementsByTagName( 'body' )[0];
  root.classList.remove(newclass);
  root.style.overflow = "visible";
});



$(".fa-close").click(function(){
   $('.add_to_cart_container').removeClass('block');
});
// small cart popup by ritu end....

// cart drawer free gift 
$('body').on('click','.check_cart',function(e){
  e.preventDefault();
  $.getJSON('/cart.json', function(cart, index){
    var gwp_product_var_id = window.theme.gwp_product;
    console.warn(gwp_product_var_id);
    var total = cart.total_price;
    var cart_item = JSON.stringify(cart.items);
    var cart_free_item_match = cart_item.match(gwp_product_var_id);
    console.warn(cart_free_item_match);
    if(cart_free_item_match != null && total > 99900){
      window.location.href ='/checkout??step=contact_information';
    }
    else if(cart_free_item_match == null){
       window.location.href ='/checkout??step=contact_information';
    }
  });
});

// article-banner-link-in-article
 $(".template-article .article__excerpt__image img").click(function(){
 location.reload();
});

   $('#shopify-section-announcement .close_announce_bar').click(function(){
      $('#shopify-section-announcement .announcement__wrapper').fadeOut();
     console.log('clicked test');
  });




// product-in-article
var location_href = window.location.toString();
var blogs = location_href.indexOf("blogs");
// if (blogs != -1) {
//   let ph_1 = document.querySelector(".ph_1").innerHTML;
//   let ph_2 = document.querySelector(".ph_2").innerHTML;
//   let ph_3 = document.querySelector(".ph_3").innerHTML;
//   let ph_4 = document.querySelector(".ph_4").innerHTML;

//   let p_i_a_1 = document.querySelector(".p_i_a_1");
//   let p_i_a_2 = document.querySelector(".p_i_a_2");
//   let p_i_a_3 = document.querySelector(".p_i_a_3");
//   let p_i_a_4 = document.querySelector(".p_i_a_4");
  
//   if(p_i_a_1 != null){
//     document.querySelector(".p_i_a_1").innerHTML = ph_1;
//   }
//   if(p_i_a_2 != null){
//     document.querySelector(".p_i_a_2").innerHTML = ph_2;
//   }
//   if(p_i_a_3 != null){
//     document.querySelector(".p_i_a_3").innerHTML = ph_3;
//   }
//   if(p_i_a_4 != null){
//     document.querySelector(".p_i_a_4").innerHTML = ph_4;
//   }
// }

      $('.products_in_article_container').slick({
      speed: 900,
    	arrows: true,
   		slidesToScroll: 1,
  		slidesToShow: 3,
     	infinite: true,
   		 prevArrow:'<button type="button" class="slick-prev slick_prev_arrow"><svg class="Icon Icon--select-arrow-left" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></button>',
         nextArrow:'<button type="button" class="slick-next slick_next_arrow"><svg class="Icon Icon--select-arrow-right" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg></button>',
    	responsive: [
         {
      	   breakpoint: 769,
      	   settings: {
           slidesToShow: 2,
           slidesToScroll: 1,
      	   }
    	 },
         {
      	   breakpoint: 550,
      	   settings: {
           slidesToShow: 1,
           slidesToScroll: 1,
           centerMode: true,
      	   }
    	 }
        ]
	  });

$('body').on('click', '.article_go_checkout', function(){
  const this_ = $(this);
  var product_article_blog = $('.products_in_article_container .product_article_blog');
  let arr_id = [];
  product_article_blog.each((i,blog) => {
    console.log("blog>>",blog);
    variant_id = $(blog).attr('variant-id');
    if(typeof(variant_id) != 'undefined'){
      arr_id[i] = variant_id;
    }
  });
  console.log("arr_id>>",arr_id);
  let article_blogs = arr_id.filter((item, index) => arr_id.indexOf(item) === index);
 console.log("article_blogs>>>",article_blogs);
  $.getJSON('/cart',function(cart){
    var cart_total = cart.item_count;
    localStorage.setItem('CartItem',cart_total);
  });
  var cart_totals = localStorage.getItem('CartItem');
  console.log("cart_total>>",cart_totals);
  const v_i_length = article_blogs.length - 1;
  var v_id_count = 0;
  article_blogs.forEach((v_id,i) => {
    v_id_count = v_id_count + i ;
    //alert(v_id_count,"v_id_count")
  });
 // console.log("v_id_count",v_id_count);
  var totalQ = parseInt(cart_totals) + parseInt(v_id_count);
  console.log("totalQ",totalQ)
  if(totalQ < 25){
  if(article_blogs.length != 0){
    this_.addClass('is-loading');
    let checkLimit_;
    article_blogs.forEach((v_id,i) => {
       //alert();
      console.log("v_id>>>",v_id);
      let checkLimit_1 = window.cart.checkMaxlimit(v_id,1).then(result => {checkLimit_ = result});
     
      // if(checkLimit_){
     // alert("kkk")
        $.ajax({
          url: '/cart/add.js',
          method: 'POST',
          data: {
          quantity: 1,
          id: v_id
          },
          async: false,
          dataType: 'json', 
          success: function(result){
            
              window.cart.getCart();
              window.cart.openCartDropdown();
              this_.removeClass('is-loading');
            
          },
          catch: function(err){
            console.log('error',result);
          }
        });
      // }else{
      //   this_.removeClass('is-loading');
      // }
    });
  }
  }
  else{
     var btn =  document.querySelector('.article__wrapper').querySelector('.cart_err');
                        console.log("btn>>>",btn)
                          btn.classList.add('active');
                          setTimeout(function(){
                          btn.classList.remove('active');                                   
                          },2000);
  }
});

 $(document).ready(function() {
      // Event listener for add to cart buttons

     $(document).on("click",".product__submit__add, #desktop-atc, #mobile-atc",function() {
        const productId = $(this).parents('.product-form').find('#Current_Var_Id').val(); 
        console.log('product id is' + productId);
        var current = $(this); 
       console.log('productId limit 1 : ' + JSON.stringify(productId));   
        getCart().done(function(cart) {
          // Find the specific product variant in the cart
          const cartItem = cart.items.find(item => item.variant_id == productId );
          const currentQuantity = cartItem ? cartItem.quantity : 0;
        console.log('productId limit :'  + cartItem + " : "+currentQuantity); 
          
          if (currentQuantity <= 3) {
             current.parents('.product-form').find('.product-upsell__errors').removeClass('is-visible'); 
             current.parents('.product-form').find('.quantity__input').removeClass('qty-disabled');
                return false;
          } 
          if (currentQuantity > 3) {
            // $('.product-upsell__errors').removeClass('is-visible');
            current.parents('.product-form').find('.product-upsell__errors').addClass('is-visible');
            // <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><g stroke="#979797" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M.5.5l26 26M26.5.5l-26 26"></path></g></svg>
            current.parents('.product-form').find('.product-upsell__errors').html('<div class="errors limit-msg font-gotham-bold">Max. Qty Reached<span class="errors__close" data-close-error=""></span></div>');
            // alert('You can only add a maximum of 5 of this product variant to the cart');
             current.parents('.product-form').find('.product__submit__add').addClass('qty-limit-disabled');
             current.parents('.product-form').find('.quantity__input').addClass('qty-disabled');
            // setTimeout(function(){
            //   $('.add_to_cart_container').addClass("cartpophide");
            //   setTimeout(function(){
            //       $('.add_to_cart_container').removeClass("cartpophide");
            //   },7500);
            // },100);
          }
        }).fail(function() {
          alert('Error fetching cart data');
        });
      });
    

   $(document).on('click', '.productdrawer-variant', function() {
       const productId = $(this).attr('data-id'); 
       const product_variant_image = $(this).attr('data-variant_image'); 
        console.log('product id is' + productId + 'product_variant_image: ' + product_variant_image);
        var current = $(this); 
     current.parents('.product-item').find('.product_main_img').addClass('variant-image-added');
     current.parents('.product-item').find('.product_main_img').css('background-image' , 'url('+ product_variant_image + ')');
       console.log('productId limit 1 : ' + JSON.stringify(productId));   
        getCart().done(function(cart) {
          // Find the specific product variant in the cart
          const cartItem = cart.items.find(item => item.variant_id == productId );
          const currentQuantity = cartItem ? cartItem.quantity : 0;
        console.log('productId limit :'  + cartItem + " : "+currentQuantity); 
          
          if (currentQuantity < 5) {
              current.parents('.product-information').find('.product-upsell__errors').removeClass('is-visible'); 
             current.parents('.product-information').find('.product__submit__add').removeClass('qty-limit-disabled');
                return false;
          } 
          if (currentQuantity > 4) {
            // $('.product-upsell__errors').removeClass('is-visible');
            current.parents('.product-information').find('.product-upsell__errors').addClass('is-visible');
            // <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><g stroke="#979797" fill="none" fill-rule="evenodd" stroke-linecap="square"><path d="M.5.5l26 26M26.5.5l-26 26"></path></g></svg>
            current.parents('.product-information').find('.product-upsell__errors').html('<div class="errors limit-msg font-gotham-bold">Max. Qty Reached<span class="errors__close" data-close-error=""></span></div>');
            // alert('You can only add a maximum of 5 of this product variant to the cart');
            current.parents('.product-information').find('.product__submit__add').addClass('qty-limit-disabled');
            setTimeout(function(){
              document.querySelector('.add_to_cart_container').classList.add("cartpophide");
              setTimeout(function(){
                  document.querySelector('.add_to_cart_container').classList.remove("cartpophide");
              },7500);
            },100);
          }
        }).fail(function() {
          alert('Error fetching cart data');
        });
   });
   $('body').on('click', '.errors__close', function() {
      $('.product-upsell__errors').removeClass('is-visible');
   });
  
   $('body').on('click', '.cart__quantity-plus', function() {
      const productId = $(this).attr('data-variant-id'); 
      console.log('product id is' + productId);
      var current = $(this); 
     console.log('productId limit 1 : ' + JSON.stringify(productId));   
      setTimeout(function(){
      getCart().done(function(cart) {
        // Find the specific product variant in the cart
        const cartItem = cart.items.find(item => item.variant_id == productId );
        const currentQuantity = cartItem ? cartItem.quantity : 0 ;
      console.log('productId limit :'  + JSON.stringify(cartItem) + " : "+currentQuantity); 
        console.log(currentQuantity+1);
        if (currentQuantity <= 4) {
           // $('.product-upsell__errors').removeClass('is-visible'); 
              return false;
        } 
        if (currentQuantity == 5) {
              $.ajax({
              type: 'GET',
              url: '/cart.js',
              dataType: 'json',
              success: function(cart) {
              updateVariantQuantities(cart); 
              },
              error: function(xhr, status, error) {
              console.error('Error fetching cart:', error);
              }
              });

        }
      }).fail(function() {
        alert('Error fetching cart data');
      });
      },3000);
   
     
    });


  // Fetch the cart content
    $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
    updateVariantQuantities(cart);
    // var cart_count = cart.item_count;  
    // $('body').attr('data-cart_count', cart_count); 
    },
    error: function(xhr, status, error) {
    console.error('Error fetching cart:', error);
    }
    });

    // Function to update variant quantities
  function updateVariantQuantities(cart) {
      cart.items.forEach(function(item) {
          var variantId = item.variant_id;
          var quantity = item.quantity;
          // Update the input field with the corresponding variant ID
          // $('[data-qty-variant-id="' + variantId + '"] .quantity__input').val(quantity);
          if (quantity == 5) {
            
              console.log('variantId cart limit: ' + variantId);

            $('.product-form input[name="id"]').each(function() {
              var $quantityElements = $(this).val();
              var current = $(this); 
            if(variantId == $quantityElements){
               console.log('$quantityElements: '+ $quantityElements);
              current.parents('.product-form').addClass('test-form-cart');
               current.parents('.product-form').find('.product__submit__add').addClass('qty-limit-disabled');
               current.parents('.product-form').find('.product-upsell__errors').addClass('is-visible');
                current.parents('.product-form').find('.product-upsell__errors').html('<div class="errors limit-msg font-gotham-bold">Max. Qty Reached</div>');
            }
            

          });

          }
        else{
          //      $('.product-form input[name="id"]').each(function() {
          //     var $quantityElements = $(this).val();
          //     var current = $(this); 
          //   if(variantId == $quantityElements){
          //      console.log($quantityElements);
          //     current.parents('.product-form').addClass('test-form-cart');
          //      current.parents('.product-form').find('.product__submit__add').removeClass('qty-limit-disabled');
          //      current.parents('.product-form').find('.product-upsell__errors').removeClass('is-visible');
               
          //   }
            

          // });
        }
        
          console.log('variantId ajax check: ' + variantId);

          $('[data-qty-variant-id="' + variantId + '"]').addClass('active');


          



      });
  }

   $('body').on('click', '.cart__quantity-minus, .cart-item__remove', function() {
      const productId = $(this).attr('data-variant-id'); 
      console.log('product id is' + productId);
      var current = $(this); 
     console.log('productId limit 1 : ' + JSON.stringify(productId));   
      setTimeout(function(){
            $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: function(cart) {
             cart.items.forEach(function(item) {
              var variantId = item.variant_id;
              var quantity = item.quantity;
              // Update the input field with the corresponding variant ID
              // $('[data-qty-variant-id="' + variantId + '"] .quantity__input').val(quantity);
              if (quantity < 5) {
            
                  console.log('variantId cart limit: ' + variantId);
                current.parents('.product-form').find('.quantity__input').removeClass('qty-disabled');
                $('.product-form input[name="id"]').each(function() {
                  var $quantityElements = $(this).val();
                  var current = $(this); 
                if(variantId == $quantityElements){
                       console.log($quantityElements);
                      current.parents('.product-form').addClass('test-form-cart');
                       current.parents('.product-form').find('.product__submit__add').removeClass('qty-limit-disabled');
                       current.parents('.product-form').find('.product-upsell__errors').removeClass('is-visible');
                       current.parents('.product-form').find('.product-upsell__errors').html('<div class="errors limit-msg font-gotham-bold">Max. Qty Reached</div>');
                }

             });

          }
          console.log('variantId ajax check: ' + variantId);


        });
    },
    error: function(xhr, status, error) {
    console.error('Error fetching cart:', error);
    }
    });

         
      },3000);
   
     
    });

   // $('body').on('click', '.cart-item__remove, .cart__quantity-minus', function() {
   //     $.ajax({
   //  type: 'GET',
   //  url: '/cart.js',
   //  dataType: 'json',
   //  success: function(cart) {
   //  updateVariantQuantities(cart); 
   //  },
   //  error: function(xhr, status, error) {
   //  console.error('Error fetching cart:', error);
   //  }
   //  });
   // });

   function setThirdDivPaddingTop() {
    var firstDivHeight = $('#shopify-section-announcement').outerHeight(); // Get outer height including padding and border
    var secondDivHeight = $('.theme__header').outerHeight(); // Get outer height including padding and border
    var combinedHeight = firstDivHeight + secondDivHeight;
    
    var headerh = document.getElementById("my_sticky_header");
    var stickyh = headerh.offsetTop;
    var headerheighth = $(headerh).height() + 20;
    if($(this).scrollTop() >= 70 ){
      //console.log("100plus");
      $('#header-menu .drawer__content').css('padding-top', headerheighth);
    }
     else{
       $('.header__drawer .drawer__content').css('padding-top', combinedHeight + 'px');
       console.log('combinedHeight' + combinedHeight);
     }
  }

    function filter_top_space() {
    var firstDivHeight = $('#shopify-section-announcement').outerHeight(); // Get outer height including padding and border
    var secondDivHeight = $('.theme__header').outerHeight(); // Get outer height including padding and border
    var combinedHeight = firstDivHeight + secondDivHeight;
    
    var headerh = document.getElementById("my_sticky_header");
    var stickyh = headerh.offsetTop;
    var headerheighth = $(headerh).height() + 20;
    if($(this).scrollTop() >= 70 ){
      console.log("100plus");
      $('.collection__sidebar__slider.expanded1').css('top', headerheighth);
    }
     else{
       $('.collection__sidebar__slider.expanded1').css('top', combinedHeight + 'px');
       console.log('combinedHeight' + combinedHeight);
     }
  }
  
  // Call the function initially
  setThirdDivPaddingTop();
  
  // Call the function whenever the window is resized
  $(window).on('resize', function() {
    setTimeout(function(){
       setThirdDivPaddingTop();
      },500);
  });
   $(window).on('scroll', function() {
      setTimeout(function(){
       setThirdDivPaddingTop();
      },500);
  });
   $(document).on('click', '.close_announce_bar', function() {
		
       setTimeout(function(){
   setThirdDivPaddingTop();
      },500);
  });
}); 
 

// end product-in-article
   

//--------- read more on collection/product content------------
window.addEventListener('DOMContentLoaded', function() {
if(document.querySelectorAll('.coll_readmore').length != 0){
  document.querySelector('.coll_readmore').addEventListener('click',function (event) {
    event.preventDefault();
    var readMoreMain = this.closest('.content_in_footer').querySelector('.coll_readMoreMain');
    var readLess = this.closest('.content_in_footer').querySelector('.coll_readLess');
    var readMore = this.closest('.content_in_footer').querySelector('.coll_readMore');
    if(readMoreMain && readLess) {
      readMoreMain.classList.remove('fixed_read_more_truncate');
      readLess.classList.remove('d_none');
      readMore.classList.add('d_none')
    }
  });
  document.querySelector('.coll_readless').addEventListener('click',function (event) {
    event.preventDefault();
    var readMoreMain = this.closest('.content_in_footer').querySelector('.coll_readMoreMain');
    var readLess = this.closest('.content_in_footer').querySelector('.coll_readLess');
    var readMore = this.closest('.content_in_footer').querySelector('.coll_readMore');
    if(readMoreMain) {
      readMoreMain.classList.add('fixed_read_more_truncate');
      readLess.classList.add('d_none');
      readMore.classList.remove('d_none')
    }
  }); 
}
  // for PDP read more button
  if(document.querySelectorAll('.readmore').length > 0){
  document.querySelector('.readmore').addEventListener('click',function (event) {
    event.preventDefault();
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'none';
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'block';
    return false;
  });
  document.querySelector('.readless').addEventListener('click',function (event) {
    event.preventDefault();
    var descriptionShort = document.querySelector('.product-description-short');
    descriptionShort.style.display = 'block';
    var descriptionFull = document.querySelector('.product-description-full');
    descriptionFull.style.display = 'none';
    // window.scrollTo({top: 10, behavior: 'smooth'});
  });
}
});
//--------- end read more on collection/product content------------

// check variant not more than 5 to be add to cart  

 function getCart() {
      return $.ajax({
        url: '/cart.js',
        dataType: 'json'
      });
    }

  $(".popout--sort .popout__toggle").click(function(e){
   $(this).attr('aria-expanded', function(i, attr) {
                  return attr === 'true' ? 'false' : 'true';
              });
          $('#sort-list').toggleClass('popout-list--visible');
  });

   $(document).on('click', '.popout--sort .popout__toggle', function() {
         $(this).attr('aria-expanded', function(i, attr) {
                  return attr === 'true' ? 'false' : 'true';
              });
          $('#sort-list').toggleClass('popout-list--visible');
      });


  var flkty = new Flickity('#cart_recommendations', {
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        prevNextButtons: false
    });
  
    // Fetch the cart contents using Shopify's AJAX API

  function reintializerecomendations(){
      if (flkty) {
                      flkty.destroy();
                      console.log("Flickity slider destroyed.");
                      } else {
                      console.log("Flickity is not initialized.");
                      }
                      var flkty = new Flickity('#cart_recommendations', {
                      cellAlign: 'left',
                      contain: true,
                      wrapAround: true,
                      prevNextButtons: false
                      });
                 var $carousel = $('#cart_recommendations').flickity();

                  // expand gallery by toggling class
                  $carousel.toggleClass('is-expanded').flickity('resize');
  }
    
        function recomendation_update(){
          setTimeout(function(){
          $.getJSON('/cart.js', function(cart) {
               console.log('Product in Cart ajax: '); 
             // alert('recomendation_update start');
              // Create an array to hold the product IDs in the cart
              var productsInCart = cart.items.map(function(item) {
                  return item.id; // Get the product ID
              });
           console.log(productsInCart);
              // Loop through each product on the page
            
              console.log('recomendation_update remove');
                      $('.cartslider-products').show();
                     $('.cartslider-products').removeClass('incart_pro');
               
                     reintializerecomendations();
            
              $('.cartdrawer-variant').each(function() {
                  var productId = $(this).data('id');
                   var productmainId = $(this).data('product-id');
                 var cart_mainproduct_id = $(this).parents('.cartslider-products').data('product-id');
                
                  // Check if the product ID is in the cart
                  if (productsInCart.includes(productId)) {
                       // alert(productmainId + ' : ' +cart_mainproduct_id);
                         // alert('recomendation_update success');
                    console.log('Product in Cart: ' + productId); 
                      // Hide the product if it's already in the cart
                    $(this).parents('.cartslider-products[data-product-id="' + productmainId + '"]').hide();
                    $(this).parents('.cartslider-products').addClass('incart_pro');

                    reintializerecomendations();
                 
                  }
                 
              });
          });
          },2000);
      }
      recomendation_update();
       $(document).on('click', '.product__submit__add, .cart-item__remove', function() {
          console.log('Product in Cart clicked: '); 
      recomendation_update();
     });


// Wishlist popup code 

    $(document).on('click', '.wislist-cart-remove-btn', function() {
     
         // $('.cart-dropdown').animate({ scrollTop: 0 }, 500);
         var product_id= $(this).data('product-id');
         var product_handle = $(this).data('product-handle');
        var variant_id = $(this).data('variant-id');
        var  cart_pro_img_url =  $(this).parents('.cart-item').find('.cart-item__image img').attr('src');
           // alert(variant_id);
       $('#remove_wishlist').attr('data-variant-id', variant_id);
       // $('.cart-item__remove[data-variant-id="'+variant_id+'"]').addClass('cart-remove-item-wishlist');
      $('#addto_wishlist').attr('data-pid', product_id);
      $('#addto_wishlist').attr('data-handle', product_handle);
        $('#addto_wishlist').attr('data-variant-id', variant_id);
      $('.product-wishlist_img img').attr('src', cart_pro_img_url);
       window.wishlistInit();    
       // alert('product_id:' + product_id +  ' product_handle: ' + product_handle + 'cart_pro_img_url: ' + cart_pro_img_url);
       $('#addto_wishlist').append('<svg height="18" width="18" class="svg-loader"><circle r="7" cx="9" cy="9"></circle><circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle></svg>');
      $('#addwishlist_cart').show();
     $('#cart-dropdown').addClass('wishlist-cart-popup-overlay');
     });

    // Add an event listener to button1
    $(document).on('click', '#remove_wishlist', function() {
      var current = $(this);
      current.addClass('is-loading-wish');
       var variant_id = $('#remove_wishlist').attr('data-variant-id');
       $('.cart-item__remove[data-variant-id="'+variant_id+'"]').removeClass('cart-remove-item-wishlist');
      $('.cart-item__remove[data-variant-id="'+variant_id+'"]').click();

       setTimeout(function(){
       current.removeClass('is-loading-wish');
       $('#addwishlist_cart').hide();
       $('#cart-dropdown').removeClass('wishlist-cart-popup-overlay');
     },3300);
         var data = {
                        id: variant_id,
                        quantity: 0,
                       snippets:['cart-drawer']   
                    };

       $.ajax({
                        type: 'POST',
                        url: '/cart/change.js',
                        data: data,
                        dataType: 'json',
                        success: function(updatedCart) {
                            // alert('cart updated');
                            console.log('Cart updated:', updatedCart);
                                window.cart.getCart(); 
                        },
                        error: function(xhr, status, error) {
                            console.error('Error updating cart:', error);
                        }
                    });
       
     });
  
   $(document).on('click', '#addto_wishlist', function() {
       var current = $(this);
      current.addClass('is-loading-wish');
      setTimeout(function(){
          $('#addto_wishlist').append('<svg height="18" width="18" class="svg-loader"><circle r="7" cx="9" cy="9"></circle><circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9"></circle></svg>');
         },300);
       
         var variant_id = $(this).attr('data-variant-id');
           setTimeout(function(){
           current.removeClass('is-loading-wish');
           $('#addwishlist_cart').hide();
           $('#cart-dropdown').removeClass('wishlist-cart-popup-overlay');
         },3300);
       
           var data = {
                        id: variant_id,
                        quantity: 0,
                       snippets:['cart-drawer']   
                    };

            $.ajax({
                        type: 'POST',
                        url: '/cart/change.js',
                        data: data,
                        dataType: 'json',
                        success: function(updatedCart) {
                            // alert('cart updated');
                            console.log('Cart updated:', updatedCart);
                                window.cart.getCart(); 
                        },
                        error: function(xhr, status, error) {
                            console.error('Error updating cart:', error);
                        }
                    });
     });

  $(document).on('click', '.close_popup_wishlist', function() {
     $('#addwishlist_cart').hide();
           $('#cart-dropdown').removeClass('wishlist-cart-popup-overlay');

   });

 $('.add_TO_Cart').click(function(){  
    setTimeout(function(){
        $('#FreeGiftMain').css('display','none');
     $('.cart-dropdown__items, .cart__foot-inner, .footer__drawer_checkout').css('display','block');
    },2000);
    });

